jQuery(document).ready(function ($) {

  const intersitialForm         = $('#form-intersitial');
  const intersitialInputPhone   = $('#intersitial-form-phone');
  const intersitialInputCpfCnpj = $('#intersitial-form-cpfcnpj');
  const intersitialInputCep     = $('#intersitial-form-cep');
  var inputValues               = [];


  formValidateConfig(intersitialForm);
  maskPhone(intersitialInputPhone);
  maskCpfCnpj(intersitialInputCpfCnpj);
  maskCep(intersitialInputCep);
  validatorEmail();
  validatorPhone();
  validatorCep();
  validatorCpfCnpj();

  $('#intersitial-form-optin').on('click', function () {
    $(this).prop('checked', true)
  })

  intersitialForm.on('submit',function (e) {
    e.preventDefault();

    if ($(this).valid()) {

      const form = $('#intersitial-modal form');

      // Pega o texto e os links do disclaimer
      var disclaimer = [];
      var lgpd_disclaimer = [];
      form.find('.lgpd-disclaimer').each(function() {
        if($(this).find('input:checked').length > 0){
          var text  = $(this).text().replace(/\\n|\s{2,}/gm, ' ').trim();
          var url = $(this).find('a');
          var url_ref = '';
          url.each(function(){
            url_ref += $(this).attr('href');
            url_ref += ' ; ';
          });
          disclaimer = {
            text_disclaimer    :text,
            url_disclaimer     :url_ref
          };
          lgpd_disclaimer.push(disclaimer);
        }
      });

      const lead = {
        fullname       : form.find('#intersitial-form-fullname').val(),
        name           : form.find('#intersitial-form-fullname').val().split(' ')[0],
        surname        : form.find('#intersitial-form-fullname').val().substr($(this).find('#intersitial-form-fullname').val().indexOf(' ') + 1),
        email          : form.find('#intersitial-form-email').val(),
        phone          : intersitialInputPhone.val(),
        cpf            : intersitialInputCpfCnpj.val(),
        cep            : intersitialInputCep.val(),
        optins         : form.find('#intersitial-form-optin').val() === 'true' ? {'estadao':true} : {'estadao':false},
        url_page       : window.location.href,
        lgpd_disclaimer: lgpd_disclaimer,
        getParameters : {
          utm_source  : form.find('#intersitial-utm-source').val()
        }
      };
      const slug = [];
      const offers = [];

      if($(this).find('input[name="offers"]:checked').length > 0){
         $(this).find('input[name="offers"]:checked').each(function() {
          offers.push($(this).val());
        });
      $(this)
        .find('input[name="offers"]:checked')
        .each(function () {
          var classeDoInput = $(this).attr("class"); // Obtém a classe do input atual
          slug.push(classeDoInput);
        });

        lead["slug"] = slug;
        lead['offers'] = offers;

        var url_send_lead = 'https://leadspublidigital.estadao.com.br';

        if(window.location.origin == "https://dev.jornaldocarro"){
          url_send_lead = "http://dev.leadspublidigital";
        }

        if(window.location.origin == "https://qajornaldocarro.estadao.com.br"){
          url_send_lead = "https://qaleadspublidigital.estadao.com.br";
        }

         $.ajax({
           url: url_send_lead + "/api/jornaldocarro/v1/receive-callback-popup",
           type: "POST",
           data: {
             action: "jc_ajax_send_intersitial_lead",
             data: lead,
           },
           beforeSend: function () {
             intersitialForm.find(":submit").prop("disabled", true);
             intersitialForm.find(":submit").val("Enviado...");
             intersitialForm.find(":submit").css("background", "#949494");
           },
           success: function (response) {
             $(".intersitial-form").css("display", "none");
             $(".intersitial-offers").css("display", "none");
             $(".intersitial-mobile-submit").css("display", "none");
             $(".intersitial-thankyou-message").css({
                display: "flex",
                height: "auto",
                opacity: 1,
                overflow: "unset",
                visibility: "visible",
             });
             response.array_lead.forEach(function (id) {
               pintrk("track", "lead", {
                 lead_type: "Intersitial",
                 order_id: id,
               });
             });
           },
         });

      } else {
        alert('Por favor, selecione uma oferta');
      }
    } else {
      intersitialForm.find(':submit').focus();
      showFormErrors();
    }
  })

  $('#form-intersitial').find('input[type="text"], input[type="email"], input[type="tel"]').on('click', function () {
    setInputValue($(this))
  })

  $('#form-intersitial').find('input[type="text"], input[type="email"], input[type="tel"]').on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;

    if (keyCode === 9) {
      e.preventDefault();
      setInputValue($(this))
    }
  })


  function setInputValue(element){

    inputValues.forEach(function (value) {
      if(value.id === element.attr('id') && value.error){
        setInputPlaceholder(element);
        element.val(value.text)
      }
    });

    element.removeAttr('style');
  }

  function setInputPlaceholder(element) {
    switch (element.prop('name')) {
      case 'name':
        element.prop('placeholder', 'Nome completo*')
        break;
      case 'email':
        element.prop('placeholder', 'E-mail')
        break;
      case 'phone':
        element.prop('placeholder', 'Telefone')
        break;
      case 'cpfcnpj':
        element.prop('placeholder', 'CPF')
        break;
      case 'cep':
        element.prop('placeholder', 'CEP')
        break;
    }
  }

  function showFormErrors() {

    inputValues = []

    $('#form-intersitial').find('input[type="text"], input[type="email"], input[type="tel"]').each(function(){

      if($(this).attr('aria-invalid') === "true" || $(this).val() === "") {

        inputValues.push({
          id:$(this).attr('id'),
          text:$(this).val(),
          error: true
        });

        $(this).val('');
        $(this).prop('placeholder', 'Por favor, preencha o campo corretamente');
        $(this).blur();
        setErrorInputStyle($(this))
      }
    })
  }

  function setErrorInputStyle(element) {
    element.css('border-color', '#DC3545')
    element.css('color', '#DC3545');
    element.css('border-width', '2px')
    element.css('border-style', 'solid')
    element.css('background', '#FFCDBC')
  }

});
